// extracted by mini-css-extract-plugin
export default {"full_wrapper":"user-message_full_wrapper__ov05h","wrapper":"user-message_wrapper__IPUAp","bounceIn":"user-message_bounceIn__wjT2S"};